import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { NovidadeSistema } from "../model/NovidadeSistema.model";
import { NotificacaoUsuarioSistema } from "../model/NotificacaoUsuarioSistema.model";

@Injectable({ providedIn: 'root' })
export class NotificacaoBarService {

    private notificacaoBarAbertoSubject = new BehaviorSubject<boolean>(false);
    private novidadesDoSistemaSubject = new BehaviorSubject<NovidadeSistema[]>([]);
    private notificacacoesSubject = new BehaviorSubject<NotificacaoUsuarioSistema[]>([]);
    private mudancaNotificacaoSubject = new Subject<void>();

    notificacaoBarAberto$ = this.notificacaoBarAbertoSubject.asObservable();
    novidadesDoSistema$ = this.novidadesDoSistemaSubject.asObservable();
    notificacoes$ = this.notificacacoesSubject.asObservable();
    mudancaNotificacao$ = this.mudancaNotificacaoSubject.asObservable();

    abrir(novidadesDoSistema : NovidadeSistema[], notificacoes: NotificacaoUsuarioSistema[]) {
        this.notificacaoBarAbertoSubject.next(true);
        this.novidadesDoSistemaSubject.next(novidadesDoSistema);
        this.notificacacoesSubject.next(notificacoes);
    }

    fechar() {
        this.notificacaoBarAbertoSubject.next(false);
    }

    notificarMudanca() {
        this.mudancaNotificacaoSubject.next();
    }

    


}